import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./components/App";
import { Version } from './providers/dataProvider';

const root = ReactDOM.createRoot(document.getElementById(`lc-${Version}-root`));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
